import React, { useEffect, useRef } from 'react';
import './App.css';
import Sidebar from './components/Sidebar';
import { Outlet, useLocation } from 'react-router-dom';

function App() {
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  const location = useLocation();

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (container) {
      container.scrollTo({ top: 0, behavior: 'auto' });
    }
  }, [location.pathname]);

  return (
    <div className="App">
      <Sidebar />
      <div className="main-content" ref={scrollContainerRef}>
        <header className="App-header">
          <div className="logo-container">
            <span className="logo-icon">🌿</span>
            <h1>AI中医医疗助手</h1>
          </div>
          <div className="header-subtitle">
            专业、智能的医疗咨询服务
          </div>
        </header>
        <main>
          <Outlet />
        </main>
        <footer className="App-footer">
          <p>© 2025 AI中医医疗助手 · 仅供参考，非医疗建议</p>
        </footer>
      </div>
    </div>
  );
}

export default App;
